// External social and contact links
// Update these in one place to change links across the entire site
export const links = {
  github: "https://github.com/AxiomLabsSolutions",
  linkedin: "https://linkedin.com/company/axiomlabs",
  twitter: "https://x.com/Axiomlabssol",
  email: "axiomlabssolutions@gmail.com",
};

export default links;
